import React, {Component} from 'react'
import LinkWithTooltip from '../../tooltip';
import _ from 'lodash';
import ResponsiveManager from '../../ResponsiveManager'

class Slider extends Component {

  onChangeHandle(event){
    const { input: { value, onChange, name }, params } = this.props
    
    if(params.responsive){
      if(_.isObject(value)){
        let newValue = Object.assign({},value)
        newValue[event.target.dataset.device] = event.target.value
        onChange(newValue);
      } else {
        let newTempValue = {
          md: value,
          sm: '',
          xs: '',
        }
        newTempValue[event.target.dataset.device] = event.target.value
        onChange(newTempValue);
      }

    } else {
      onChange(event.target.value);
    }
    
  }

  render(){
    const { input, params, responsiveDevice } = this.props


    const max = params.max ? params.max : 100;
    const min = params.min ? params.min : 0;
    const step = params.step ? params.step : 1;
    
    var activeClassName = 'sp-pagebuilder-device-tabs sp-pagebuilder-device-'+responsiveDevice;
    var activeClassContainer = 'sppb-responsive-inputs sp-pagebuilder-device-'+responsiveDevice;

    let inputValue = {};


    if(typeof input.value !== 'object'){
      inputValue = {
        md: input.value
      }
    } else {
      inputValue = input.value
    }
    
    return(
      <div className="sp-pagebuilder-form-group">
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
          {
            params.responsive &&
            <ul className={activeClassName}>
              <li><i className="fa fa-laptop md" onClick={e => {
                  ResponsiveManager.setDevice('md');
                }}></i></li>
              <li><i className="fa fa-tablet sm" onClick={e => {
                  ResponsiveManager.setDevice('sm');
                }}></i></li>
              <li><i className="fa fa-mobile xs" onClick={e => {
                  ResponsiveManager.setDevice('xs');
                }}></i></li>
            </ul>
          }
        </label>
        {
          params.responsive &&
          <div className={activeClassContainer}>
            <div className="sp-pagebuilder-range-input md">
                <input value={inputValue.md}  max={max} min={min} step={step} data-device="md" type="range" onChange={ this.onChangeHandle.bind(this) } />
                <input value={inputValue.md}  max={max} min={min} step={step} data-device="md" type="number" className="" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />
            </div>
            <div className="sp-pagebuilder-range-input sm">
                <input value={inputValue.sm}  max={max} min={min} step={step} data-device="sm" type="range" onChange={ this.onChangeHandle.bind(this) } />
                <input value={inputValue.sm}  max={max} min={min} step={step} data-device="sm" type="number" className="" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />
            </div>
            <div className="sp-pagebuilder-range-input xs">
                <input value={inputValue.xs}  max={max} min={min} step={step} data-device="xs" type="range" onChange={ this.onChangeHandle.bind(this) } />
                <input value={inputValue.xs}  max={max} min={min} step={step} data-device="xs" type="number" className="" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />
            </div>
          </div>
        }
        {
          !params.responsive &&
          <div className="sp-pagebuilder-range-input">
            <input {...input} max={max} min={min} step={step} type="range" onChange={ this.onChangeHandle.bind(this) } />
            <input {...input} max={max} min={min} step={step} type="number" className="" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />
          </div>
        }
        
      </div>
    )
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Slider.js